import { WlWindow } from 'typings/globals/cordova';

import {
  BookingConfirmed,
  BusinessEvent,
  BusinessEventHandler,
} from '../../businessLayer';

declare const window: WlWindow;

const tradetrackerHandler: BusinessEventHandler = (evt: BusinessEvent) => {
  console.log(`[TradeTracker] Received event [type: ${evt.type}]`, evt);
  try {
    if (evt.type === 'BookingConfirmed') {
      const event = evt as BookingConfirmed;
      const eventData = event.getEventData();

      const trackingObject = {
        type: 'sales',
        campaignID: TRADETRACKER_CAMPAIGN_ID,
        productID: TRADETRACKER_PRODUCT_ID,
        transactionID: eventData.trip_id,
        transactionAmount: eventData.amount,
        quantity: '1',
        descrMerchant: eventData.trip_title,
        descrAffiliate: eventData.area,
        currency: eventData.currency,
        vc: eventData.coupon_code,
        trackingGroupID: TRADETRACKER_TRACKING_GROUP_ID,
      };

      window.ttConversionOptions = window.ttConversionOptions || [];
      window.ttConversionOptions.push(trackingObject);

      function trackConversion(ttConversionOptions: any) {
        const campaignID =
          'campaignID' in ttConversionOptions
            ? ttConversionOptions.campaignID
            : 'length' in ttConversionOptions && ttConversionOptions.length
              ? ttConversionOptions[0].campaignID
              : null;
        const tt = document.createElement('script');
        tt.type = 'text/javascript';
        tt.async = true;
        tt.src = `https://partner.withlocals.com/conversion?s=${encodeURIComponent(
          campaignID,
        )}&t=m`;
        document.head.appendChild(tt);
      }

      trackConversion(window.ttConversionOptions);

      console.log('[TradeTracker] Conversion tracked', trackingObject);
    }
  } catch (error: any) {
    console.error(
      `[TradeTracker] Failed handling of event [type: ${evt.type}]`,
      evt,
    );
  }
};

export { tradetrackerHandler };
